import React, { useState } from "react";

//PropTypes
import PropTypes from "prop-types";

//UI Material
import { Button, Grid, Stack, Typography } from "@mui/material";

//Material Icons
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";

export default function QuoteSummary({ data }) {
  // ==========>Component States<==========
  const [showDetails, setShowDetails] = useState(false);

  //Date formatting
  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  // ==========>Component<==========
  return (
    <Grid container spacing={1} textAlign="left">
      <Grid item xs={12}>
        <Stack>
          <Typography fontWeight="bold">Nombre del cliente</Typography>
          <Typography> {data.client.name}</Typography>
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <Stack>
          <Typography fontWeight="bold">Fecha de creación</Typography>
          <Typography>
            {new Date(data.createdAt).toLocaleDateString("es-ES", options)}
          </Typography>
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <Stack>
          <Typography fontWeight="bold">Fecha de vencimiento</Typography>
          <Typography>
            {new Date(data.expirationDate).toLocaleDateString("es-ES", options)}
          </Typography>
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <Button
          sx={{ color: "secondary" }}
          variant="text"
          startIcon={!showDetails ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
          onClick={() => setShowDetails(!showDetails)}
        >
          {showDetails ? "ver menos información" : "ver más información"}
        </Button>
      </Grid>
      {showDetails && (
        <Grid item xs={12}>
          <Stack>
            <Typography fontWeight="bold">Usuario generador</Typography>
            <Typography>{data.createdBy}</Typography>
          </Stack>
        </Grid>
      )}
    </Grid>
  );
}

// ==========>Component PropTypes<==========
QuoteSummary.propTypes = {
  data: PropTypes.object,
};
